import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "gfu-project-bottom-bar gfu-project-bottom-bar--compact"
}
const _hoisted_2 = { class: "gfu-project-bottom-bar__content gfu-project-bottom-bar__content--absolute" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createBlock(_Transition, {
    name: $options.transitionName,
    onAfterEnter: _cache[0] || (_cache[0] = $event => (_ctx.$emit('after-enter')))
  }, {
    default: _withCtx(() => [
      ($options.isBottomBarVisible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default")
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["name"]))
}